import type { ReactNode } from "react";
import { allDocPages } from "../content";
import DocsLayout from "../layout";
import { CoverageTable, Legend } from "./components";

const rows = [
  {
    market: "Nasdaq Basic & Last Sale",
    historical: "N", delayed: "N", realTime: "Y", level2: "N",
    agreements: "https://www.nasdaqtrader.com/Trader.aspx?id=AgreementsData",
    priceList: "https://www.nasdaqtrader.com/Trader.aspx?id=DPPriceListAll",
  },
  {
    market: "CBOE One",
    historical: "N", delayed: "Y", realTime: "A", level2: "N",
    agreements: "https://markets.cboe.com/us/equities/support/market_data/",
    priceList: "https://markets.cboe.com/us/equities/membership/fee_schedule/",
  },
  {
    market: "CBOE BZX",
    historical: "N", delayed: "Y", realTime: "A", level2: "N",
    agreements: "https://markets.cboe.com/us/equities/support/market_data/",
    priceList: "https://markets.cboe.com/us/equities/membership/fee_schedule/bzx",
  },
  {
    market: "CBOE EDGX",
    historical: "N", delayed: "Y", realTime: "A", level2: "N",
    agreements: "https://markets.cboe.com/us/equities/support/market_data/",
    priceList: "https://markets.cboe.com/us/equities/membership/fee_schedule/edgx/",
  },
  {
    market: "US Equities - A Feed (NYSE)",
    historical: "Y", delayed: "A", realTime: "A", level2: "A",
    agreements: "https://www.ctaplan.com/contracts#110000001418",
    priceList: "https://www.ctaplan.com/pricing#110000093271",
  },
  {
    market: "US Equities - B Feed (NYSE MKT)",
    historical: "Y", delayed: "A", realTime: "A", level2: "A",
    agreements: "https://www.ctaplan.com/contracts#110000001418",
    priceList: "https://www.ctaplan.com/pricing#110000093271",
  },
  {
    market: "US Equities - C Feed (Nasdaq)",
    historical: "Y", delayed: "A", realTime: "A", level2: "A",
    agreements: "http://www.utpplan.com/data_admin",
    priceList: "http://www.utpplan.com/DOC/Datapolicies.pdf",
  },
  { market: "FINRA OTC", historical: "Y", delayed: "Y", realTime: "N", level2: "N", agreements: null, priceList: null },
  {
    market: "TSX & TSX Venture",
    historical: "Y", delayed: "Y", realTime: "A", level2: "A",
    agreements: "https://www.tmxinfoservices.com/tmx-datalinx/products-and-services/product-sheets-and-pricing",
    priceList: null,
  },
  {
    market: "Canadian Securities Exchange",
    historical: "Y", delayed: "Y", realTime: "A", level2: "A",
    agreements: "https://thecse.com/en/services/market-data",
    priceList: "https://thecse.com/services/market-data/fee-schedule",
  },
  {
    market: "Aequitas Neo Exchange",
    historical: "A", delayed: "A", realTime: "A", level2: "A",
    agreements: "https://www.aequitasneo.com/en/exchange/resources?item=market-data-agreements",
    priceList: null,
  },
  {
    market: "London Stock Exchange",
    historical: "Y", delayed: "Y", realTime: "A", level2: "A",
    agreements: "https://www.londonstockexchange.com/products-and-services/market-data/realtimedata/pricesandpolicies/pricesandpolicies.htm",
    priceList: null,
  },
  {
    market: "Euronext",
    historical: "Y", delayed: "Y", realTime: "A", level2: "A",
    agreements: "https://www.euronext.com/en/data/market-data/market-data-pricing-policies",
    priceList: null,
  },
  {
    market: "CBOE Europe",
    historical: "Y", delayed: "Y", realTime: "A", level2: "A",
    agreements: "https://markets.cboe.com/europe/equities/support/market_data/",
    priceList: null,
  },
  { market: "XETRA", historical: "A", delayed: "A", realTime: "A", level2: "A", agreements: null, priceList: null },
  {
    market: "Australian Stock Exchange",
    historical: "Y", delayed: "Y", realTime: "A", level2: "A",
    agreements: "https://www.asxonline.com/marketinfo/product.shtm",
    priceList: null,
  },
  {
    market: "BM&F Bovespa",
    historical: "A", delayed: "A", realTime: "A", level2: "A",
    agreements: "http://www.b3.com.br/en_us/market-data-and-indices/data-services/market-data/distributors/contracts-and-commercial-policy/",
    priceList: null,
  },
  {
    market: "Bursa Malaysia",
    historical: "A", delayed: "A", realTime: "A", level2: "A",
    agreements: "http://www.bursamalaysia.com/market/products-services/information-products/information-services-licence/",
    priceList: null,
  },
  {
    market: "NASDAQ OMX Nordic",
    historical: "A", delayed: "A", realTime: "A", level2: "A",
    agreements: "https://business.nasdaq.com/intel/GIS/nordic-baltic-pricing.html",
    priceList: null,
  },
  { market: "Tokyo Stock Exchange", historical: "A", delayed: "A", realTime: "A", level2: "A", agreements: null, priceList: null },
  { market: "Shanghai Stock Exchange", historical: "A", delayed: "A", realTime: "A", level2: "A", agreements: null, priceList: null },
  { market: "Shenzen Stock Exchange", historical: "A", delayed: "A", realTime: "A", level2: "A", agreements: null, priceList: null },
  { market: "New Zealand Stock Exchange", historical: "A", delayed: "A", realTime: "A", level2: "A", agreements: null, priceList: null },
  { market: "Singapore Stock Exchange", historical: "A", delayed: "A", realTime: "A", level2: "A", agreements: null, priceList: null },
  { market: "BSE India", historical: "A", delayed: "A", realTime: "A", level2: "A", agreements: null, priceList: null },
  { market: "NSE India", historical: "A", delayed: "A", realTime: "A", level2: "A", agreements: null, priceList: null },
  { market: "SIX Swiss Exchange", historical: "A", delayed: "A", realTime: "A", level2: "A", agreements: null, priceList: null },
  { market: "Taiwan Stock Exchange", historical: "A", delayed: "A", realTime: "A", level2: "A", agreements: null, priceList: null },
  { market: "Johannesburg Stock Exchange", historical: "A", delayed: "A", realTime: "A", level2: "A", agreements: null, priceList: null },
];

export default function EquitiesPage(): ReactNode {
  const page = allDocPages.find(p => p.slug === "data-coverage-equities")!;
  return (
    <DocsLayout page={page}>
      <Legend/>
      <CoverageTable rows={rows} withAgreements/>
    </DocsLayout>
  );
}
